const enTranslations = {
  "welcome": "Welcome",
  "search": "Search",
  "whatareyoulookingfor": "What are you looking for?",
  "propertiesList": "Properties List",
  "explore": "Explore",
  "exploreBy": "How would you like to explore?",
  "listView": "List View",
  "mapView": "Map View",
  "whatAreYouLookingFor": "What are you looking for?",
  "propertyType": "Property Type",
  "location": "Location",
  "noPropertiesFound": "No properties found matching your search",
  "searchForAddress": "Search for address, city, or location",
  "whatAreYouLookingForPlaceholder": "Please search for address, city, or location",
  "availableProperties": "Available Properties",
  "viewDetails": "View Details",
  "price": "Price",
  "locationDetails": "Location Details",
  "propertyDetails": "Property Details",
  "favorites": "Favorites",
  "filter": "Filter",
  "viewMore": "View More",
  "welcomeback" : "Welcome Back",
  "username" : "User Name",
  "password" : "Password",
  "enteryourusername": "Enter your username",
  "signinwithmobilenumber" : "Sign-In with Mobile Number",
  "forgotpassword" : "Forgot password",
  "Donthaveanaccount" : "Don't have an account",
  "enteryourpassword": "Enter your password",
  "exploreNewProjects": "Explore New Projects",
  "projectsNearYou": "Projects Near You",
  "becomeAHost": "Become a Host",
  "generateIncome": "Generate passive income by renting or selling your properties!",
  "featuredProperties": "Featured Properties",
  "propertyNotAvailable": "This property is not available",
  // Add more translations based on the other parts of the component
  "profile": "Profile",
  "myProfile": "My Profile",
  "editProfile": "Edit Profile",
  "name": "Name",
  "email": "Email",
  "sendOTP" : "Send OTP",
  "phoneNumber": "Phone Number",
  "address": "Address",
  "language": "Language",
  "currency": "Currency",
  "referralCode": "Referral Code",
  "logout": "Logout",
  "changePassword": "Change Password",
  "settings": "Settings",
  "updateProfile": "Update Profile",
  "success": "Successfully updated",
  "error": "An error occurred",
  "termsAndConditions": "Terms and Conditions",
  "privacyPolicy": "Privacy Policy",
  "help": "Help",
  "contactUs": "Contact Us",
    "LocationEthopia": "Location Ethiopia",

    "BuyRentSell": "Buy, rent, or sell your property easily",
  "GreatPlatform": "A great platform to buy, sell, or even rent your properties without any commissions.",
"renters": "50k + renters",
  "rentersDescription": "believe in our service",
  "properties": "10k+ properties",
  "propertiesDescription": "houses ready for occupancy",
  "exploreNewProjects": "Explore new projects in Ethiopia",
  "exploreNewProjectsDescription": "Some of our picked properties near your location.",
  "exploreBy": "Explore by: ",
  "listView": "List View",
  "enter" : "Enter",
  "sendto" : "Send to",
  "mapView": "Map View",
  "propertiesList": "properties List",
  "propertiesCount": "{count} properties",
  "interestedInHosting": "Interested in hosting your own property?",
  "generateIncome": "Generate passive income by renting or selling your properties!",
  "becomeAHost": "Become a host today",
  "footer.noSpamPromise": "No Spam Promise",
  "footer.areYouLandowner": "Are you a landowner?",
  "footer.discoverWays": "Discover ways to increase your home's value and get listed. No Spam.",
  "footer.enterEmail": "Enter your email address",
  "footer.submit": "Submit",
  "footer.joinLandlords": "Join 10,000+ other landlords in our dwello community.",
  "footer.about": "ABOUT",
  "footer.company": "Company",
  "footer.howItWorks": "How it works",
  "footer.contact": "Contact",
  "footer.investors": "Investors",
  "footer.resources": "RESOURCES",
  "footer.blog": "Blog",
  "footer.guides": "Guides",
  "footer.faq": "FAQ",
  "footer.helpCenter": "Help Center",
  "footer.termsPrivacy": "TERMS & PRIVACY",
  "footer.trustSafety": "Trust & Safety",
  "footer.termsService": "Terms of Service",
  "footer.privacyPolicy": "Privacy Policy",
  "footer.copyright": "©2025. All rights reserved",


  "terms.conditions": "Terms and Conditions",
  "terms.text1": "By using the Location Real Estate App, you agree to provide accurate information and use the platform only for lawful purposes.",
  "terms.text2": "Location acts solely as a property listing platform and does not guarantee the accuracy, ownership, or availability of any property.",
  "terms.text3": "Users are responsible for verifying details and conducting transactions at their own risk.",
  "privacy.policy": "Privacy Policy",
  "privacy.text1": "The Location Real Estate App values your privacy and collects only essential information to provide our services.",
  "privacy.text2": "We do not sell or share your personal data with third parties without consent, except as required by law.",
  "privacy.text3": "By using the App, you agree to our data collection, storage, and usage practices.",
  "help.center": "Help Center",
  "help.text1": "Welcome to our Help Center! Here you can find answers to common questions, troubleshoot issues, and learn more about our services. If you can't find what you're looking for, feel free to contact us directly.",
  "contact.us": "Contact Us",
  "change.profile": "Change Profile",
  "remove.profile": "Remove Profile",
  "profile": "Profile",
  "save": "Save",
  "edit.profile": "Edit Profile",
  "edit.profile.picture": "Edit Profile Picture",
  "cancel": "Cancel",
  "save.picture": "Save",
  "zoom": "Zoom",
  "upload.picture": "Upload Picture",
  "remove.profile.confirm": "Are you sure you want to remove your profile?",
  "last.updated": "Last updated: September 2025",
  "profile.title": "Profile",
  "profile.userName": "UserName",
  "profile.phoneNumber": "Phone Number",
  "profile.emailAddress": "Email Address",
  "profile.save": "Save",
  "profile.editProfile": "Edit Profile",
  "profile.changeProfile": "Change Profile",
  "profile.removeProfile": "Remove Profile",
  "profile.uploadPicture": "Upload Picture",
  "profile.editProfilePicture": "Edit Profile Picture",
  "profile.cancel": "Cancel",
  "profile.zoom": "Zoom",
  "profile.lastUpdated": "Last updated: September 2025",
  "profile.removeProfileConfirmation": "Are you sure you want to remove your profile?",
   "savedProperties.title": "Saved properties",
  "savedProperties.errorOccurred": "Error Occurred: {{error}}",
  "savedProperties.noSavedProperties": "Looks like you haven’t saved any properties yet. Start exploring!",
  "propertyDetails.title": "Property Details",
  "propertyDetails.location": "Location",
  "propertyDetails.bedrooms": "Bedrooms",
  "propertyDetails.bathrooms": "Bathrooms",
  "propertyDetails.area": "Area",
  "propertyDetails.type": "Type",
  "propertyDetails.amenities": "Amenities",
  "propertyDetails.reviews": "Reviews",
  "propertyDetails.noReviews": "No reviews yet. Be the first to review.",
  "propertyDetails.postReview": "Post Review",
  "propertyDetails.writeReview": "Write a Review",
  "propertyDetails.submitReview": "Save",
  "propertyDetails.errorReview": "Failed to submit review",
  "propertyDetails.selectRating": "Please select a rating",
  "propertyDetails.writeSomething": "Please write something in the review",

  "activeFilters": "Active Filters",
  "Details" : "details",
  "yes": "Yes",
  "no": "No",
  "total": "Total",
  "filtered": "Filtered",
  "loadingProperties": "Loading properties...",
  "errorOccurred": "Error occurred: {{error}}",
  "retry": "Retry",
  "noPropertiesFound": "No properties found",
  "noPropertiesMatchCriteria": "No properties match your current search criteria",
  "noPropertiesAvailable": "No properties are currently available",
  "clearFilters": "Clear Filters",
  "refresh": "Refresh",
  "initializingFilters": "Initializing filters",
  "search": "Search",
  "rent":"Rent",
  "filter" : "Filter",
   "from" : "From",
  "to" : "To",
  "choosepostedby" : "Choose posted by",
  "propertypostedby" : "Property posted by",
  "typeofproperty" : "Type of property",
  "furnishingstatus" : "Furnishing Status",
  "selectfurnishing" : "Select Furnishing",
  "floorpreference" : "Floor Preference",
   "budgetrange" : "Budget range",
   "minbudget" : "Min Budget",
  "maxbudget" : "Max Budget",
  "monthly" : "Monthly",
  "selectfloor" : "Select Floor",
  "yearly" : "Yearly",
  "clearall" : "Clear All",
    "applyfilters" : "Apply Filters",
"amenitiesoffered" : "Amenities offered",
"features" : "Features",
"roomsandsleepingarrangements" : "Rooms and sleeping arrangements",
  "owner" : "Owner",
  "agent" : "Agent",
  "whatisyourintendeddurationofstay" : "What is your intended duration of stay?",
  "buy" : "Buy",
  "register" : "Register",
  "createyouraccountwith" : "Create your account with", 
  "verification" : "verification",
  "browseproperties" : "Browse Properties",
  "login": "Login",
  "signup": "Sign Up",
  "english" : "English",
  "aed" : "AED",
  "inr" : "INR",
  "usd" : "USD",
  
  "amharic" : "Amharic",
  "alllocation" : "All Location",
  "searchproperties" : "Search Properties",
  "propertytype" : "Property type",
  "apartment" : "Apartment",
  "type": "Type",
  "location": "Location",
  "bedrooms": "Bedrooms",
  "bathrooms": "Bathrooms",
  "amenities": "Amenities",
  "writeReview": "Write a Review",
  "submitReview": "Submit Review",
  "postReview": "Post Review",
  "loginToReview": "Please login to write a review",
  "writeSomething": "Please write something for the review",
  "selectRating": "Please select a rating",
  "errorReview": "Please login to submit a review",
  "submitReviewSuccess": "Review submitted successfully!",

 "appInformation": "App Information" ,

  "writeUs": "Write Us",
    "callUs": "Call Us",
          "account": "Account",

 "home": "Home",
    "post": "Post",
    "profile": "Profile",
    "saved": "Saved"
};

export default enTranslations;
